import api from '../lib/api';

class ScreenConnectService {
  async createSession(assetId, assetName, technicianName) {
    try {
      const response = await api.post('/screenconnect/sessions/create', null, {
        params: {
          asset_id: assetId,
          asset_name: assetName,
          technician_name: technicianName
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating session:', error);
      throw error;
    }
  }

  async getSessionStatus(sessionId) {
    try {
      const response = await api.get(`/screenconnect/sessions/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching session status:', error);
      throw error;
    }
  }

  async getAssetSessions(assetId) {
    try {
      const response = await api.get(`/screenconnect/assets/${assetId}/sessions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset sessions:', error);
      throw error;
    }
  }

  async getActiveSessions() {
    try {
      const response = await api.get('/screenconnect/active-sessions');
      return response.data;
    } catch (error) {
      console.error('Error fetching active sessions:', error);
      throw error;
    }
  }

  async checkHealth() {
    try {
      const response = await api.get('/screenconnect/health');
      return response.data;
    } catch (error) {
      console.error('Error checking health:', error);
      throw error;
    }
  }

  async syncMachines() {
    try {
      const response = await api.post('/screenconnect/sync-machines');
      return response.data;
    } catch (error) {
      console.error('Error syncing machines:', error);
      throw error;
    }
  }

  async getMachines(assetId) {
    try {
      const params = {};
      if (assetId) params.asset_id = assetId;
      
      const response = await api.get('/screenconnect/machines', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching machines:', error);
      throw error;
    }
  }


  async getWebhookSessions() {
    try {
      const response = await api.get('/screenconnect/webhook-sessions');
      return response.data;
    } catch (error) {
      console.error('Error fetching webhook sessions:', error);
      throw error;
    }
  }

  async getWebhookUrl() {
    try {
      const response = await api.get('/screenconnect/webhook-url');
      return response.data;
    } catch (error) {
      console.error('Error fetching webhook URL:', error);
      throw error;
    }
  }


  getGuestJoinUrl(sessionId) {
    const baseUrl = process.env.REACT_APP_SCREENCONNECT_URL || process.env.REACT_APP_BACKEND_URL?.replace('/api', '');
    if (!baseUrl) {
      console.error('REACT_APP_SCREENCONNECT_URL not configured');
      return '#';
    }
    // Format: /Guest#Access/{SessionID}/Join
    return `${baseUrl}/Guest#Access/${sessionId}/Join`;
  }

  getHostJoinUrl(sessionId) {
    const baseUrl = process.env.REACT_APP_SCREENCONNECT_URL || process.env.REACT_APP_BACKEND_URL?.replace('/api', '');
    if (!baseUrl) {
      console.error('REACT_APP_SCREENCONNECT_URL not configured');
      return '#';
    }
    // Correct format: /Host#Access/All%20Machines/{SessionID}/General/
    return `${baseUrl}/Host#Access/All%20Machines/${sessionId}/General/`;
  }
}

export default new ScreenConnectService();
